import { exitingGroupDetailResponseModel, userGroupResponseModel } from "../../models/memberAxiosModels";

export const intialGroupDetail: exitingGroupDetailResponseModel = {
    groupId: 0,
    groupName: "",
    isDefaultGroup: false,
    apps: [
      {
        appId: 0,
        appShortName: "",
        appName: "",
        appStatus: {
          appStatusId: 0,
          appStatusName: ""
        },
        appDescription: null,
        appImage: "",
        appFeaturedImage: "",
        appCreatedAt: "",
        appUpdatedAt: "",
        appAddedToGroupAt: "",
        appUpdatedInGroupAt: ""
      }
    ]
  };
  

  export const intialUserGroup: userGroupResponseModel= {
    groups: [
      {
      groupId: 0,
      groupName: "string",
      isDefaultGroup: true,
      groupCreatedAt: "string",
      groupUpdatedAt: "string",
      groupDeletedAt: null,
      activeUserCount: 0
    }
  ]} 